<template>
  <div class="ui-card">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Card',
})
</script>

<style lang="stylus">
.ui-card
  position relative
  display flex
  flex-direction column
  border-radius .25rem
  background-color #fff
  box-shadow 0 25px 50px rgba(8, 21, 66, .06)
  background-clip border-box
  margin-bottom 30px
  &:last-child
    margin-bottom 0
</style>
